import { render, staticRenderFns } from "./cabinet-fl44-external-purchase-block-request-card.vue?vue&type=template&id=72ef6554&scoped=true&"
import script from "./cabinet-fl44-external-purchase-block-request-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-external-purchase-block-request-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl44-external-purchase-block-request-card.vue?vue&type=style&index=0&id=72ef6554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ef6554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ef6554')) {
      api.createRecord('72ef6554', component.options)
    } else {
      api.reload('72ef6554', component.options)
    }
    module.hot.accept("./cabinet-fl44-external-purchase-block-request-card.vue?vue&type=template&id=72ef6554&scoped=true&", function () {
      api.rerender('72ef6554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/block-requests/partials/cabinet-fl44-external-purchase-block-request-card.vue"
export default component.exports